import { useCustomerValue } from "providers/CustomerContext";
import SOLog from "layouts/views/outbound/return-order/components/ReturnLog";
import QCInspectionLog from "layouts/views/outbound/return-order/components/QCInspectionLog";
import { Checkbox, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDButton from "components/MDButton";
import { useCallback, useEffect, useState } from "react";
import { getRecvReturn } from "services/data.outbound.service";

import { Success, Error_, LoadingDialog } from "ui-components/Alert";
import { TableCard } from "ui-components/Layout";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
// import PickslipLog from "./PickslipLog";
import MDBadge from "components/MDBadge";
// import PickslipPickScanLog from "./PickslipPickScanLog";
// import PickslipPackScanLog from "./PickslipPackScanLog";
import { ListLayout } from "ui-components/Layout";

function ReturnOrderManagement() {
  const { customerCode } = useCustomerValue();
  const [recvReturnList, setRecvReturnList] = useState([]);
  const [logRequest, setLogRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const logProp = { open, setOpen, logRequest, setLogRequest };
  const [returnLogRequest, setReturnLogRequest] = useState(null);
  const [returnOpen, setReturnOpen] = useState(false);
  const [dialog, setDialog] = useState(null);
  const [type, setType] = useState("ALL");
  //console.log(user.userId)

  useQuery({
    queryKey: ["recv-return",{customerCode}],
    queryFn: () => {
      console.log("Fetching recv-return with customerCode:", customerCode);
      return getRecvReturn({ customerCode });
    },
    onSuccess: (data) => {
      console.log("Successfully retrieved recv-return data:", data);
      //setUserOptions(data.data.data);
      setRecvReturnList(data.data.data);
    },
    enabled:true
  });

  const returnLogProp = {
    open: returnOpen,
    setOpen: setReturnOpen,
    logRequest: returnLogRequest,
    setLogRequest: setReturnLogRequest,
  };
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const recvordercolumns = [
   {
     accessorKey: "recvReturnNo",
     header: "Return No",
     width: 120,
   },
   
    // {
    //   accessorKey: "carrierCode",
    //   header: "Carrier Code",
    //   width: 140,
    // },
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 155,
    },
    {
      accessorKey: "referenceNo",
      header: "Reference No",
      width: 150,
    },
    {
      accessorKey: "trackingNumber",
      header: "Tracking Number",
      width: 100,
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 140,
      cell: ({ row }) => {
        const { orderNumber } = row.original;
        return (
          <span
            style={{
              color: "#1A73E8",
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setOpen(true);
              setLogRequest({ orderNumber, customerCode });
            }}
          >
            {orderNumber}
          </span>
        );
      },
    },
    {
      accessorKey: "Status",
      header: "QC Inspection Status",
      width: 120,
      cell: ({ row }) => {
        console.log(row.original,"row.originalqcinspection");
        const { orderNumber, pickingStatus, status } = row.original;
        //console.log({pickslipNumber, pickingStatus },"testpickingstatus");
        const onClick = () => {
          setReturnOpen(true);
          setReturnLogRequest({ orderNumber });
        };
        if (status === "O")
          return <Badge color="warning" content="QC Scan" onClick={onClick} />;
        if (status === "A")
          return <Badge color="success" content="Finish Return" onClick={onClick} />;
        if (status === "P")
          return <Badge color="success" content="Return Putaway" onClick={onClick} />;
        return <div></div>;
      },
    },
    {
      accessorKey: "userID",
      header: "User ID",
      width: 120,
    },
    {
      accessorKey: "createdOn",
      header: "Created On",
      width: 120,
    },
    {
      accessorKey: "returnDate",
      header: "Return Date",
      width: 120,
    },
  ];

  const queryClient = useQueryClient();
  return (
    <>
      {dialog}
      {/* {<LoadingDialog />} */}
      <SOLog {...logProp} />
      <QCInspectionLog {...returnLogProp} />
<ListLayout lg={12}>
      <TableCard sx={{ marginTop: 4 }}>
         <CheckboxTable2
          data={recvReturnList}
          columns={recvordercolumns}
          //onSelectedRowsChange={handleChange}
        />
      </TableCard>
      </ListLayout>
    </>
  );
}

const Badge = ({ color, content, onClick }) => {
  return (
    <MDBadge
      sx={{ cursor: "pointer" }}
      onClick={onClick}
      variant="gradient"
      color={color}
      size="xs"
      badgeContent={content}
      container
    />
  );
};

export default ReturnOrderManagement;
